<script setup>
import { computed, defineAsyncComponent } from 'vue';
import useVuelidate from '@vuelidate/core';
import { useJobDataStore } from '../../stores/job-store';
import { customFieldTypes } from '../../utils/custom-fields';
import CustomFieldRadio from './customFields/CustomFieldRadio.vue';
import CustomFieldCheckbox from './customFields/CustomFieldCheckbox.vue';
import CustomFieldText from './customFields/CustomFieldText.vue';
import CustomFieldNumber from './customFields/CustomFieldNumber.vue';
import CustomFieldDate from './customFields/CustomFieldDate.vue';

const jobData = useJobDataStore();

/**
 *
 * @type {ComputedRef<CustomField[]>}
 */
const customFields = computed(() => jobData.customFields);

const customFieldComponents = {
    radio: CustomFieldRadio,
    checkbox: CustomFieldCheckbox,
    text: CustomFieldText,
    number: CustomFieldNumber,
    date: CustomFieldDate,
    // currently unused custom field types, make synchronous if needed
    dropdown: defineAsyncComponent(() => import('./customFields/CustomFieldDropdown.vue')),
    tag: defineAsyncComponent(() => import('./customFields/CustomFieldTag.vue')),
};

if (import.meta.env.MODE === 'development') {
    /* Check + warn if not all possible types have associated components with them */
    Object.values(customFieldTypes).forEach((type) => {
        // eslint-disable-next-line no-prototype-builtins
        if (!customFieldComponents.hasOwnProperty(type) || customFieldComponents[type] == null) {
            // eslint-disable-next-line no-console
            console.warn(`Warning: No component associated with type '${type}'`);
        }
    });
}

const v$ = useVuelidate({ $registerAs: 'customFields' });

defineExpose({ v$ });
</script>

<template>
    <div
        data-qa="custom fields"
        class="flex flex-col gap-xl"
    >
        <div
            v-for="field in customFields"
            :key="field.id"
            data-qa="custom field"
        >
            <component
                :is="customFieldComponents[field.type]"
                v-bind="field"
                v-model="field.value"
            />
        </div>
    </div>
</template>
